import { useTranslations } from "@zapier/i18n";

import {
  Button,
  ModalDialogBody,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogRoot,
  Spacer,
  Text,
} from "@zapier/design-system";

export interface SharingRemovalPromptProps {
  assetTitle: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export function SharingRemovalPrompt({
  assetTitle,
  onConfirm,
  onCancel,
}: SharingRemovalPromptProps) {
  const t = useTranslations("sharing-removal-prompt");

  return (
    <ModalDialogRoot isOpen={true}>
      <ModalDialogHeader>
        {t("header.move-to-top-level", { assetTitle })}
      </ModalDialogHeader>
      <ModalDialogBody>
        <Text tag="p">{t("messages.sharing-inheritance-warning")}</Text>
        <Spacer height="1em" />
        <Text tag="p">{t("messages.reshare-after-move")}</Text>
      </ModalDialogBody>
      <ModalDialogFooter>
        <Button variant="secondary" onClick={onCancel}>
          {t("buttons.cancel")}
        </Button>
        <Button onClick={onConfirm}>{t("buttons.move-folder")}</Button>
      </ModalDialogFooter>
    </ModalDialogRoot>
  );
}
